import { render, staticRenderFns } from "./compose-user.vue?vue&type=template&id=5ae3d1ac"
import script from "./compose-user.vue?vue&type=script&lang=ts"
export * from "./compose-user.vue?vue&type=script&lang=ts"
import style0 from "./compose-user.vue?vue&type=style&index=0&id=5ae3d1ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports